import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53541624"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "text-4xl mb-16" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Grading Helper ")
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "mb-4 flex flex-col" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "total",
  title: "The total number of points the student can earn on this assignment"
}, "Points possible:", -1))
const _hoisted_7 = { class: "flex w-full" }
const _hoisted_8 = ["disabled", "readonly"]
const _hoisted_9 = ["title", "textContent"]
const _hoisted_10 = ["textContent"]
const _hoisted_11 = { class: "mb-4 flex flex-col" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "points_missed",
  title: "The number of points the student missed on the assignment."
}, "Points missed:", -1))
const _hoisted_13 = ["max"]
const _hoisted_14 = { class: "mt-16" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "font-bold" }, "Enter values above to calculate", -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "font-bold text-red-800 text-sm" }, " Score is not between zero and one hundred ", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { class: "font-bold" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Final Score: ")
const _hoisted_24 = ["title", "textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeIcon())),
        textContent: _toDisplayString(_ctx.icon)
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          id: "total",
          ref: "totalRef",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.total) = $event)),
          class: _normalizeClass(["border rounded p-4 flex-grow dark:text-gray-800 dark:bg-gray-200 disabled:dark:bg-gray-400 disabled:cursor-not-allowed min-w-0 max-w-full", { invalid: _ctx.errorMsg !== '' }]),
          type: "text",
          inputmode: "decimal",
          autocomplete: "off",
          min: "0",
          disabled: _ctx.locked,
          readonly: _ctx.locked,
          onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.validateTotal())),
          onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.errorMsg = ''))
        }, null, 42, _hoisted_8), [
          [
            _vModelText,
            _ctx.total,
            void 0,
            { number: true }
          ]
        ]),
        _createElementVNode("button", {
          class: "p-2 rounded ml-2",
          title: 'Press to ' + (_ctx.locked ? 'unlock' : 'lock'),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleLock())),
          textContent: _toDisplayString(!_ctx.locked ? '🔒' : '✏️')
        }, null, 8, _hoisted_9)
      ]),
      _createElementVNode("p", {
        class: "text-sm text-red-600",
        textContent: _toDisplayString(_ctx.errorMsg)
      }, null, 8, _hoisted_10)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _withDirectives(_createElementVNode("input", {
        id: "points_missed",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.points_missed) = $event)),
        class: "border rounded p-4 dark:text-gray-800 dark:bg-gray-200 min-w-0 max-w-full",
        min: "0",
        type: "text",
        inputmode: "decimal",
        autocomplete: "off",
        max: _ctx.total
      }, null, 8, _hoisted_13), [
        [
          _vModelText,
          _ctx.points_missed,
          void 0,
          { number: true }
        ]
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      (isNaN(_ctx.score) || !isFinite(_ctx.score))
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
        : (_ctx.score < 0 || _ctx.score > 100)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
          : (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("h2", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("span", {
                  class: "pl-4 circled",
                  title: _ctx.score,
                  textContent: _toDisplayString(_ctx.score.toFixed(0) + '%')
                }, null, 8, _hoisted_24)
              ])
            ]))
    ])
  ]))
}